import { GetDocumentoComercialImportadoByIdDtoProps } from "./DTOs/GetDocumentoComercialImportadoByIdDto"
import { GetDocumentosComercialesImportadosByFiltersDtoProps } from "./DTOs/GetDocumentosComercialesImportadosByFiltersDto"

export function GetDocumentoComercialImportadoByIdAdapter(
  documento: GetDocumentoComercialImportadoByIdDtoProps
): GetDocumentoComercialImportadoByIdDtoProps {
  return {
    id: documento.id,
    baseImponible: documento.baseImponible,
    cliente: documento.cliente,
    conceptos: documento.conceptos,
    descuento: documento.descuento,
    fechaEmision: documento.fechaEmision,
    ficheroId: documento.ficheroId,
    importe: documento.importe,
    numero: documento.numero,
    proveedor: documento.proveedor,
    retencion: documento.retencion,
  }
}

export function GetDocumentosComercialesImportadosByFiltersAdapter(
  documento: GetDocumentosComercialesImportadosByFiltersDtoProps
): GetDocumentosComercialesImportadosByFiltersDtoProps {
  return {
    id: documento.id,
    fechaEmision: documento.fechaEmision,
    importe: documento.importe,
    numero: documento.numero,
    razonSocial: documento.razonSocial,
    tipo: documento.tipo,
  }
}
